import { isDevMode, Injectable } from '@angular/core';

@Injectable()
export class AppModeProviderService {
  isAppInDevMode(): boolean {
    return isDevMode();
  }
}
